/*
 * Figma `48:27` — Status Badge. Tone: Neutral, Accent, Success, Warning, Danger.
 *
 * The label is required and the dot is always drawn. Both are the same rule: a badge that says what
 * it means only in its fill is unreadable to anyone who cannot separate the fills, and "colour is
 * not the only indicator of state" is an acceptance check, not a preference.
 */
import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger';

export function StatusBadge({ tone = 'neutral', children, title }: {
  tone?: BadgeTone;
  children: ReactNode;
  title?: string;
}) {
  return (
    <span className="jt-badge" data-tone={tone} title={title}>
      <span className="jt-badge-dot" aria-hidden="true" />
      {children}
    </span>
  );
}
